import { Action } from "@ngrx/store";

export const AUTH_KEY = "AUTH";

export enum AuthActionTypes {
  LOGIN = "[Auth] Login",
  LOGOUT = "[Auth] Logout"
}

export class ActionAuthLogin implements Action {
  readonly type = AuthActionTypes.LOGIN;

  constructor(
    readonly payload: {
      isAdmin: boolean;
      isPlanner: boolean;
      isViewer: boolean;
      fullName: string;
      allowResourceLocking: boolean;
      allowAudit: boolean;
      allowForceBooking: boolean;
      allowPriorityReservation: boolean;
    }
  ) {}
}

export class ActionAuthLogout implements Action {
  readonly type = AuthActionTypes.LOGOUT;
}

export type AuthActions = ActionAuthLogin | ActionAuthLogout;

export const initialState: AuthState = {
  isAuthenticated: false,
  isAdmin: false,
  isPlanner: false,
  isViewer: false,
  allowResourceLocking: false,
  allowAudit: false,
  allowForceBooking: false,
  allowPriorityReservation: false,
  fullName: "Unknown User"
};

export const selectorAuth = (state) => <AuthState>state.auth;

export function authReducer(
  state: AuthState = initialState,
  action: AuthActions
): AuthState {
  switch (action.type) {
    case AuthActionTypes.LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        isAdmin: action.payload.isAdmin,
        isPlanner: action.payload.isPlanner,
        isViewer: action.payload.isViewer,
        allowResourceLocking: action.payload.allowResourceLocking,
        allowAudit: action.payload.allowAudit,
        allowForceBooking: action.payload.allowForceBooking,
        allowPriorityReservation: action.payload.allowPriorityReservation,
        fullName: action.payload.fullName
      };

    case AuthActionTypes.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        isAdmin: false,
        isPlanner: false,
        isViewer: false,
        fullName: "Unknown User"
      };
    default:
      return state;
  }
}

export interface AuthState {
  isAuthenticated: boolean;
  isAdmin: boolean;
  isPlanner: boolean;
  isViewer: boolean;
  allowResourceLocking: boolean;
  allowAudit: boolean;
  allowForceBooking: boolean;
  allowPriorityReservation: boolean;
  fullName: string;
}
